import { render, staticRenderFns } from "./JVxeUploadCell.vue?vue&type=template&id=050f42ac&scoped=true"
import script from "./JVxeUploadCell.vue?vue&type=script&lang=js"
export * from "./JVxeUploadCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f42ac",
  null
  
)

export default component.exports